import { type ContentItem, type ObjectDto } from '@bizzdesign/shared/models';
import { iSystemAttributesToSystemAttributes } from '@bizzdesign/shared/utils';

export function mapObjectDtoToContentItem(object: ObjectDto): ContentItem {
  return {
    id: object.id,
    typeName: object.type,
    scope: 'object',
    name: object.name ?? '',
    metaModel: object.metaModel,
    isRepo: true,
    description: '',
    externalId: object.externalId ?? undefined,
    externalSource: object.externalSource ?? undefined,
    systemAttributes: iSystemAttributesToSystemAttributes(
      object.systemAttributes!,
    ),
  };
}
